import { Box, FormControl, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent } from '@mui/material';
import { styled } from '@mui/material/styles';

import { FC, useMemo } from 'react';
import format from 'date-fns/format';
import { INotificationHeaderProps } from './types';
import { useNotificationSelector } from './NotificationContext';

const StyledBox = styled(Box)({
  '& .MuiFormControl-root': {
    width: '180px',
  },
  '& .MuiInputBase-root': {
    borderRadius: '8px',
  },
});

export const NotificationContentHeader: FC<INotificationHeaderProps> = ({ allNotifications }) => {
  const { dateFilter, setDateFilter } = useNotificationSelector();

  const dateOptions = useMemo(() => {
    let yearOptions = allNotifications.map((item) => ({
      value: format(new Date(item?.uploadedOn), 'EEEE, dd-MMM-yyyy'),
      label: format(new Date(item?.uploadedOn), 'iii, dd-MMM-yyyy'),
    }));

    yearOptions = yearOptions.filter((value, index, array) => array.findIndex((item) => item?.value === value?.value) === index);

    return [
      {
        value: 'ALL',
        label: 'View All',
      },
      ...yearOptions,
    ];
  }, [allNotifications]);

  const handleChange = (event: SelectChangeEvent<string>) => {
    setDateFilter(event.target.value);
  };

  return (
    <div className='px-24 py-20 flex items-center gap-24'>
      <div>
        <h3 className='flex items-center gap-10'>
          <strong className='text-16 xl:text-18 font-bold'>Notifications</strong>
          <span className='text-14 xl:text-16 font-medium text-[#BFBFBF]'>{allNotifications?.length}</span>
        </h3>
        <p className='text-12 xl:text-14 font-medium text-blue_grey-30'>for Invoices Uploaded in the System in the last 30 days</p>
      </div>

      <div className='ml-auto'>
        <StyledBox>
          <FormControl size='small'>
            <InputLabel>View</InputLabel>
            <Select
              id='notif-filter-date'
              value={dateFilter}
              onChange={handleChange}
              input={<OutlinedInput label='View' />}
              disabled={allNotifications?.length < 1}
              renderValue={(value) => {
                const selected = dateOptions?.find((option) => option.value === value)?.label;
                return <span className='capitalize text-14 xl:text-16'>{selected}</span>;
              }}
            >
              {dateOptions?.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  <span className='capitalize text-14 xl:text-16'>{option.label}</span>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </StyledBox>
      </div>
    </div>
  );
};
